// extracted by mini-css-extract-plugin
export var checkbox = "_2x-0";
export var circle = "_2x-3";
export var horizontalContainer = "_2x-7";
export var sm = "_2x-5";
export var switch0 = "_2x-2";
export var switchDisabled = "_2x-8";
export var switchEnabled = "_2x-1";
export var textSwitchContainer = "_2x-9";
export var textSwitchOption = "_2x-a";
export var textSwitchOptionSelected = "_2x-b";
export var verticalContainer = "_2x-6";
export var xs = "_2x-4";